import { ref } from 'vue'
import { getUnReadNotificationCount } from '@/modules/notifications/services/Notification'
// import { Success } from '@/statusCodes.js'

export const count = ref(0)

export async function fetchUnreadNotificationCount() {
	try {
		const {data}  = await getUnReadNotificationCount()

		if (data.error) throw new Error(data.error)

		if (data.statusCode !== 1) throw new Error(data.message)
		count.value = data.data


	} catch (e) {
		console.log(e)
	}
}
